var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideSliderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40L20 40C22.2091 40 24 38.2091 24 36L24 4C24 1.79086 22.2091 2.39896e-06 20 2.53978e-06L-4.79576e-06 3.8147e-06L0 40Z",
    fill: "#6EE4D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20L13 17",
    stroke: "#0E4C54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23L10 20",
    stroke: "#0E4C54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideSliderIcon);
export default __webpack_public_path__ + "static/media/hide-slider-icon.c8c6d04b2a3cf56a66692a228acc3d22.svg";
export { ForwardRef as ReactComponent };